import { ApiKeyNameStepContentProps } from "./types";

import { Input } from "@/components/ui/input";

export const ApiKeyNameStepContent = ({
  keyName,
  onKeyNameChange,
  onSubmit,
}: ApiKeyNameStepContentProps) => (
  <div className="flex flex-col gap-1 p-1">
    <label htmlFor="api-key-name-input" className="text-sm font-medium text-gray-900">
      API Key Name
    </label>
    <Input
      id="api-key-name-input"
      placeholder="e.g. Production, Staging, CI/CD"
      value={keyName}
      onChange={event => onKeyNameChange(event.target.value)}
      onKeyDown={event => {
        if (event.key === "Enter") {
          event.preventDefault();
          void onSubmit();
        }
      }}
    />
  </div>
);
